module.exports = function(h, row) {
    if (_.isNull(row.outlet)) {
        return <i>Visible to all outlet</i>;
    }

    return row.outlet;
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/item/vuetableitem_outlet.jsx